import { fetchMe } from 'src/common/actions/me';
import connectAsync from 'src/common/utils/connectAsync';
import ResetPasswordRoute from './ResetPasswordRoute';

export default connectAsync([fetchMe])(ResetPasswordRoute);
